import { XStackProps } from '@my/ui/types'
import { groupEventByIdQuery, useGroupEventQuery } from '../../queries'
import { GroupEventRsvpStats } from '../../components'

interface GroupEventRsvpStatsContainerProps {
  eventId: string
  wrapperProps?: XStackProps
}

export const GroupEventRsvpStatsContainer = (props: GroupEventRsvpStatsContainerProps) => {
  const { data: eventData } = useGroupEventQuery({
    variables: {
      id: props.eventId,
    },
    skip: !props.eventId,
    fetchPolicy: 'cache-and-network',
  })

  const formattedEventData = groupEventByIdQuery.formatFn(eventData)
  const rsvps = formattedEventData?.rsvps

  return <GroupEventRsvpStats rsvps={rsvps} {...props.wrapperProps} />
}
